import { useCallback, useEffect, useState } from 'react';

import { getPlayerInfo } from 'services/dashboard.service';

import { PerfilDoJogador } from './realizacoes-do-semestre';

/** Perfil de `find/info`: `undefined` carregando, `null` falhou. */
export function usePerfil(chave: string | undefined) {
  const [perfil, setPerfil] = useState<(PerfilDoJogador & Record<string, any>) | null>();
  const [versao, setVersao] = useState(0);

  useEffect(() => {
    if (!chave) return;
    let descartada = false;
    setPerfil(undefined);

    getPlayerInfo(chave)
      .then(resultado => {
        if (!descartada) setPerfil(resultado ?? {});
      })
      .catch(() => {
        if (!descartada) setPerfil(null);
      });

    return () => {
      descartada = true;
    };
  }, [chave, versao]);

  const reler = useCallback(() => setVersao(atual => atual + 1), []);
  return { perfil, reler };
}
